import React, { createElement } from "react";
import parse from 'html-react-parser';
import ReactDOM from 'react-dom';
import Dimensions from "../Dimensions/Dimensions";

const SubmenuList = (props) => {

  // let isMobIsipadIsPotrait = window.deviceBasedonBodyClass == 'ipadDesktopPortrait' || window.deviceBasedonBodyClass == 'mobilePortrait' || window.deviceBasedonBodyClass =='ipadPortrait'  || window.deviceBasedonBodyClass =='androidTabPortrait';;
  // let isDesktop = !window.mob && !window.isipad;
  // let isDesktopView = window.deviceBasedonBodyClass == 'desktop' || window.deviceBasedonBodyClass == 'ipadDesktopLandscape' || window.deviceBasedonBodyClass =='ipadLandscape';
  // let isIapdDesktopLandscap  = window.deviceBasedonBodyClass == 'ipadDesktopLandscape';
 
  const { accordionMenu } = props; // here we recieved all diamension objects 
  const subMenuList = accordionMenu.items;
  // console.log("submenu list are ", subMenuList) // here we recieve all the accordion items 

  const filterMenuBasedOnConfigType = props.filterMenuBasedOnConfigType;
  const hasRadioButton = subMenuList.some(item => item.menuType === "radioButton");
  // console.log('subMenuList----');
  let filteredSubmenuList = subMenuList.filter(filterMenuBasedOnConfigType);
  filteredSubmenuList = filteredSubmenuList.filter(submenu => submenu.subMenuVisibility !== false);
  // console.log("filteredSubmenuList")
  // console.log('props.onLoadActiveradioButton ', props.onLoadActiveradioButton);
  // console.log(filteredSubmenuList,'filteredSubmenuList----');
  // window.config.nextPrevArray = [];

  return (
    <>
    <div className="accordionContent" data-id={props.accordionId}>
      {/* {additionalHeadingText ? <p>{additionalHeadingText}</p>:null} */}
      <ul className="subMenu" aria-hidden="true" role={hasRadioButton ? "radiogroup" : undefined}>
        {filteredSubmenuList.map((list, listIndex) => {
          // let isActive = props.onLoadActiveradioButton[list.featureType] == list.id;
          const hasValidDimensions = (Array.isArray(list.dimensionData) && list.dimensionData.length > 0) || (typeof list.dimensionData === "string" && list.dimensionData.trim() !== "") ;
          
          /* Update nextPrevious Array*/
          if (window.config.includeAccordionInNextPrevious === undefined || typeof window.config.includeAccordionInNextPrevious !== 'object') window.config.includeAccordionInNextPrevious = [];
          const isAccordionMenuIncludeAccordionInNextPrevious = window.config.includeAccordionInNextPrevious.findIndex(elementId => elementId === list.type);
          // console.log('nextPrevArray ',  window.config.nextPrevArray, list.type);
          const indexOfaccordionMenuinNextPreviousArray = window.config.nextPrevArray.findIndex(element => element.id === list.type);
          // console.log('indexOfaccordionMenuinNextPreviousArray ',  indexOfaccordionMenuinNextPreviousArray);
          // let accordionMenu = list.filter(element => element.id === list.type);
          if(isAccordionMenuIncludeAccordionInNextPrevious !== -1 && indexOfaccordionMenuinNextPreviousArray === -1) {
            // console.log('accordionMenu ', accordionMenu, list.type);
            // console.log('accordionMenu isAccordionMenuIncludeAccordionInNextPrevious', isAccordionMenuIncludeAccordionInNextPrevious);
            
            window.config.nextPrevArray.push(accordionMenu); 
          }
          /* Push accordion menu in allMenu array if not already present */
          if(window.config.allMenu === undefined) window.config.allMenu = [];
          const indexOfAccordionListinAllMenu = window.config.allMenu.findIndex(element => element.id === list.type);
          if(indexOfAccordionListinAllMenu === -1) {  
            window.config.allMenu.push(accordionMenu);
          }
          /* Push accordion menu in allMenu array if not already present end*/

          //
          const indexOfAccordionListinNextPreviousArray = window.config.nextPrevArray.findIndex(element => element.id === list.type);
          // console.log('isAccordionMenuIncludeAccordionInNextPrevious ', isAccordionMenuIncludeAccordionInNextPrevious, list.type);
          // console.log('indexOfAccordionListinNextPreviousArray ', indexOfAccordionListinNextPreviousArray, list.id);
          
          const indexOfListinAllSubMenu = window.config.allSubmenu.findIndex(element => element.id === list.id);
          if(indexOfListinAllSubMenu === -1) {window.config.allSubmenu.push(list);}
          const indexOfListinNextPreviousArray = window.config.nextPrevArray.findIndex(element => element.id === list.id);
          const indexOfListinallMenusArray = window.config.allMenu.findIndex(element => element.id === list.id);
          const skipInNextPrevious = window.config.skipInNextPrevious || []; //Added to skip menu which we don not require in next previous @DS
          if(indexOfListinNextPreviousArray === -1 && !skipInNextPrevious.includes(list.id)) {
            window.config.nextPrevArray.push(list); 
            // console.log('indexOfListinNextPreviousArray ', list)
          }
          /* Push all submenu in allMenu array if not already present */
          if(indexOfListinallMenusArray === -1) {  
            window.config.allMenu.push(list); 
          }
          /* Push all submenu in allMenu array if not already present end*/
          /* Update nextPrevious Array end*/
          let isActive = false;
          /*Only used for mobile potrait mode*/
          let filteredCallouText = '';
          let filteredCallouText1 = '';
          let listHasCalloutText = list.content != undefined  && list.content.length > 0;
          /*if(isMobIsipadIsPotrait)*/  if(listHasCalloutText) filteredCallouText = list.content.filter(filterMenuBasedOnConfigType);
          /*if(isMobIsipadIsPotrait)*/ if(listHasCalloutText) filteredCallouText1 = list.content1.filter(filterMenuBasedOnConfigType);
          /*Only used for mobile potrait mode*/
          
          if(list.menuType =="radioButton") {
             
                isActive = (window.selectedConfig[list.featureType] == list.id);
              // }
          } else if(list.type == "colorView") { // Added new condition for colorView type submenu
                if(window.selectedConfig['submenu_colorView'] == undefined){
                    window.selectedConfig['submenu_colorView'] = window.selectedConfig.currentSelectedSubmenu; // this line sets colormenu selected onload, we have to set currentSelectedSubmenu value in data.json in onLoadActiveradioButton
                }
                isActive = (window.selectedConfig['submenu_colorView'] == list.id);
          }
          else {
              // console.log('submenu ', window.selectedConfig['submenu_'+list.type]);
              // console.log('previous_submenu_ ', window.selectedConfig['previous_submenu_'+list.type]);
              /*Deselect submenu on mobile portrait also handled with below code */
              if(window.isMobIsipadIsPotrait){
                let isSubmenuAlreadySelectedForMobIpadPortrait = window.isMobIsipadIsPotrait && (window.selectedConfig['submenu_'+ list.type] !== window.selectedConfig['previous_submenu_'+ list.type]);
                isActive = window.selectedConfig['submenu_'+list.type] == list.id && isSubmenuAlreadySelectedForMobIpadPortrait;
                // console.log('isActive ', isActive);
              } else {
                let accordionMenu = document.querySelector("#accordion_"+list.type);
                let isAccordionActive = accordionMenu ? accordionMenu.classList.contains('active') : false;
                isActive = (window.selectedConfig['submenu_'+list.type] == list.id) && isAccordionActive;
                
                // console.log('submenu isActive ', 'submenu_'+list.type, " ", isActive, " ", isAccordionActive)
                

              }
              
              
                // if(isSubmenuAlreadySelectedForMobIpadPortrait) {
                //   setTimeout(function(){
                //     window.selectedConfig['previous_submenu_'+list.type] = ""; 
                //     console.log('previous_submenu_ should get reset......');
                //   },500);
                // }
              
              
          }
          

          
          let listMedia = list.media != undefined ? list.media[0] : {};
          let desktopPopupLeft = 0;
          let desktopPopupTop = 0;
          let desktopPopupWidth = 0;
          let desktopPopupHeight= 0;
          // console.log('listMedia ', listMedia);
          if(Object.keys(listMedia).length != 0){
            desktopPopupLeft = listMedia[window.UiUtils.getResolution()]['left'];
            desktopPopupTop = listMedia[window.UiUtils.getResolution()]['top'];
            desktopPopupWidth = listMedia[window.UiUtils.getResolution()]['width'];
            desktopPopupHeight= listMedia[window.UiUtils.getResolution()]['height'];
          }

          let popupStyle = {
              left: `calc(0px + ${desktopPopupLeft})`,
              top: desktopPopupTop,
              width: desktopPopupWidth,
              height: desktopPopupHeight,
            }

            // window.menuSubmenuTabindex += 1;/*How to use component has tabIndex till 6 so Menu tabIndex will start from 7*/
            window.menuSubmenuTabindex = props.parentIndex + 1 +  listIndex;
            
            const submenuProps = {};

            if(list.menuType !== "radioButton") {
              submenuProps["aria-label"] = list.title;
              submenuProps["role"] = "button";
              submenuProps["aria-current"]= isActive ? 'true' : "false";
              submenuProps["aria-selected"]= isActive ? 'true' : "false";

            }

            /*Dimention*/
            // if(list.dimensionData) console.log('list.dimensionData', list.dimensionData);
          return (
            list.subMenuVisibility && (
              <React.Fragment key={list.id}>
              <li
                key={list.id}
                tabIndex={-1} 
                // data-tabindex={list.menuType === "radioButton" ? -1 : props.parentIndex + 1 +  listIndex}
                data-tabindex={list.menuType === "radioButton" ? -1 : 1/*props.parentIndex + 1 +  listIndex*/}
                defaultChecked={true}
                className={`subMenuBtn ${list.menuType} ${list.type == "colorView" ? 'colorView' : ''} ${ isActive ? 'active' : ''} ${!listHasCalloutText ? 'withoutArrow' : ''}`}
                id={`menu_id_${list.id}`}
                // aria-current={`${ isActive ? 'true' : "false"}`}
                // aria-selected={`${ isActive ? 'true' : "false"}`}
                // aria-pressed={`${ isActive ? 'true' : "false"}`}
                // aria-label={list.title}
                 
                // aria-labelledby="Submenu"
                
                {...submenuProps}
                onKeyDown={(e) => {
                  if (e.key !== "Enter") {
                    return;
                  }
                  props.handleSubMenuClick(list);
                }}
                onClick={(event) => {
                  props.handleSubMenuClick(list, list.id);
                }}
              >
                {list.menuType === "radioButton" ? (
                  <>
                  <input
                  type={"radio"}
                  role={"radio"}
                  value={"product1"}
                  tabIndex={-1} 
                  // data-tabindex={props.parentIndex + 1 +  listIndex}
                  data-tabindex={1}
                  id={list.radioId}
                  className="radioFocus"
                  name={list.radioName}
                  // aria-current={`${ isActive ? 'true' : "false"}`}
                  aria-checked={`${ isActive ? 'true' : "false"}`}
                  checked={isActive}
                  onChange={(e) => {
                    props.handleSubMenuClick(list, list.id);
                  }}
                  />
                  <label id={"label_"+list.radioId} htmlFor={list.radioId} data-contentwidth={props.calcHtmlElementNoWrapWidth(list.title, props.cssVariableValues.submenuTextFontSize)}> {list.title}</label>
                  </>
                ) : ((window.mob || window.innerHeight > window.innerWidth)) || window.innerWidth < 935 ? (
                  <>
                    {(window.isMobIsipadIsPotrait && listHasCalloutText) && (
                      // <div className="accordia_icon">
                        // <svg viewBox="0 0 32 32" className="chevron" aria-hidden="true" focusable="false"><path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path></svg>
                        <svg width="32" height="32" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"  className="chevron" aria-hidden="true" focusable="false" strokeWidth="6" stroke="#000000" fill="none"><polyline points="18.86 57.47 44.12 30.84 18.86 6.58"/></svg>
                      // </div>
                    )}
                    <span className="subMenuBtnText" data-contentwidth={props.calcHtmlElementNoWrapWidth(list.title, props.cssVariableValues.submenuTextFontSize)}>{list.title}</span>
                  </>
                ) : (
                  <span className="subMenuBtnText" data-contentwidth={props.calcHtmlElementNoWrapWidth(list.title, props.cssVariableValues.submenuTextFontSize)}>{list.title} </span>
                )}
              </li>
              {(window.isMobIsipadIsPotrait && listHasCalloutText) && 
                <div className="callout">
                  <ul>
                 {list.content != undefined && filteredCallouText.map((calloutText) => {
/* //this block is commented as same functionality updated in filteredCallouText and rendered menu from there.
                    let isConfigTypeAvailable = calloutText.hasOwnProperty("configType");
                      let showCalloutText = false;
                      let showCalloutTextArray = [];
                      if(isConfigTypeAvailable) {
                        let calloutTextConfigType = Object.keys(calloutText.configType);
                        calloutTextConfigType.forEach(configTypeText => {
                          if(calloutText.configType[configTypeText].toLowerCase() == window.selectedConfig[configTypeText].toLowerCase()){
                            showCalloutTextArray.push('true');
                          } else {
                            showCalloutTextArray.push('false');
                          }
                        });
                      } else {
                        showCalloutTextArray.push('true');
                      }
                      if(showCalloutTextArray.includes('false')){
                        showCalloutText = false;
                      } else {
                        showCalloutText = true;
                      } */
  if(!calloutText.text)return ; // to avoid rendering of empty callout text and number likely when there is no text but hotspot circle is there that time  (if there no text but we need �nameOf3DObject� and �hotspotNumber�  that time it use )
  const styleClass =
  calloutText.styleType === "bullet"
    ? "bulletItem"
    : "";

  return (
    <React.Fragment key={Math.random()}>
       {Array.isArray(calloutText.subText) && calloutText.subText.length > 0 ? (<span className="textHeadline">{parse(calloutText.text)}</span>) : (

      <li className={styleClass}>{parse(calloutText.text)}</li> // Render as bullet only if no there is no any subText
      )}
    {Array.isArray(calloutText.subText) && calloutText.subText.length > 0 && (
        <ol className="subTextList">
          {calloutText.subText.map((sub, subIndex) => (
            <li key={subIndex} className="subTextItem">
              {parse(sub)}
            </li>
          ))}
        </ol>
      )}

    </React.Fragment>
  );
})}

                  </ul>
                  {/* {console.log('list.content1 ', list.content1)} */}
                    {(list.content1 != undefined && list.content1.length > 0) && filteredCallouText1.map((calloutText) => {
                      /* //this block is commented as same functionality updated in filteredCallouText and rendered menu from there.
                      let isConfigTypeAvailable = calloutText.hasOwnProperty("configType");
                      let showCalloutText = false;
                      let showCalloutTextArray = [];
                      if(isConfigTypeAvailable) {
                        let calloutTextConfigType = Object.keys(calloutText.configType);
                        calloutTextConfigType.forEach(configTypeText => {
                          if(calloutText.configType[configTypeText].toLowerCase() == window.selectedConfig[configTypeText].toLowerCase()){
                            showCalloutTextArray.push('true');
                          } else {
                            showCalloutTextArray.push('false');
                          }
                          
                        });
                      } else {
                        showCalloutTextArray.push('true');
                      }
                      if(showCalloutTextArray.includes('false')){
                        showCalloutText = false;
                      } else {
                        showCalloutText = true;
                      } */

                      return (
                        <React.Fragment key={Math.random()}>
                          {<div className="content1">
                            <p className="disclaimerItalics">{parse(calloutText.text1)}</p>
                          </div>}
                        </React.Fragment>
                      )
                    })}
                </div>
              } 
              {/* {console.log('subMenuList ', subMenuList)} */}
              
              {/* {console.log('list ', list)} */}

              {/* {here we add the condition to show the selected sub-menu callout in className } */}
              {((window.deviceBasedonBodyClass == 'desktop' || window.deviceBasedonBodyClass == 'ipadDesktopLandscape' || window.deviceBasedonBodyClass =='ipadLandscape' || window.deviceBasedonBodyClass =='androidTabLandscape')  && (list.content != undefined && list.content.length != 0 )) &&
               ReactDOM.createPortal(<div className={`popup ${window.selectedConfig['currentSelectedSubmenu'] === list.id ? 'active' : ''}`} role='dialog' id={list.popupId} style={popupStyle}>
                <h2>{parse(list.title)} </h2>
                <div className="content">
                   <ol>
                          {list.content != undefined && filteredCallouText.map((calloutText) => {

                            if (!calloutText.text) return; // to avoid rendering of empty callout text and number likely when there is no text but hotspot circle is there that time  (if there no text but we need �nameOf3DObject� and �hotspotNumber�  that time it use )
                           const styleClass =
                              calloutText.styleType === "bullet"
                                ? "bulletItem"
                                : "";
                            return (
                              <React.Fragment key={Math.random()}>

                                {Array.isArray(calloutText.subText) && calloutText.subText.length > 0 ? (<span className="textHeadline">{parse(calloutText.text)}</span>) : (
                              <li className={styleClass}>{parse(calloutText.text)}</li> // Render as bullet only if no there is no any subText
                              
                            )}
                                                        
                              {Array.isArray(calloutText.subText) && calloutText.subText.length > 0 && 
                                (
                                  <ul className="subTextList">
                                    {calloutText.subText.map((sub, subIndex) => (
                                      <li key={subIndex} className="subTextItem">
                                        {parse(sub)}
                                      </li>
                                    ))}
                                  </ul>
                                )
                              }

                              </React.Fragment>
                            )
                          })}
                        </ol>
                    {/* {console.log('list.content1 ', list.content1)} */}
                    {(list.content1 != undefined && list.content1.length > 0) && filteredCallouText1.map((calloutText) => {
                      
                      return (
                        <React.Fragment key={Math.random()}>
                          {<div className="content1">
                            <p className="disclaimerItalics">{parse(calloutText.text1)}</p>
                          </div>}
                        </React.Fragment>
                      )
                    })}
                  </div>
              </div>, document.getElementById('popupContainer'))

              }
              {/*- Dimention component added here so that it will render only for those submenus which have dimensionData object*/}
              {hasValidDimensions &&  <Dimensions list={list} ></Dimensions>}  
              </React.Fragment>
              
            )
          );
          // {console.log(list)}
          
        })}
      </ul>
    </div>
    </>
  );
};

export default SubmenuList;
